import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'

const useStyles = makeStyles((theme: Theme) => ({
  aboutUsDescr: {
    '&&': {
      color: '#181F32', // Not affected by theme switch
      position: 'absolute',
      top: '22%',
      left: '20%',
      transform: 'translateX(-50%)',
      fontSize: 36,
      fontWeight: '700',
      width: 350,
      lineHeightw: 1.25,
    },
  },
  aboutUsDescrAccent: {
    color: '#3FACA8', // Not affected by theme switch
  },
}))

export { useStyles }
